<!--
 * @Author: cryi.liu
 * @Date: 2020-04-30 11:01:35
 * @LastEditTime: 2020-05-01 15:54:00
 * @Description: 原 PSS 风格头部
 -->
<template>
  <header class="pss__header">
    <div class="pss__header-left">
      <brand />
    </div>
    <div class="pss__header-right">
      <user-info />
      <logout-btn />
    </div>
  </header>
</template>

<script>
import Brand from './Brand.vue';
import UserInfo from './UserInfo.vue';
import LogoutBtn from './LogoutBtn.vue';

export default {
  name: 'PssHeader',
  components: {
    Brand,
    UserInfo,
    LogoutBtn,
  },
};
</script>

<style lang="less" scoped>
.pss__header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 70px;
  background-color: #000;
  padding: 0 48px;
  box-sizing: border-box;

  &-right {
    padding-top: 36px;
    font-size: 12px;
  }
}
</style>
